import { applyPatch } from "fast-json-patch";
const defaultApplyPatch = (previous, patch) => {
    const result = applyPatch(previous, patch, true, false);
    return result.newDocument;
};
/**
 * Create a middleware generator function for applying live query patches on the client.
 */
export const createApplyLiveQueryPatch = (args) => {
    var _a;
    const applyPatch = (_a = args === null || args === void 0 ? void 0 : args.applyPatch) !== null && _a !== void 0 ? _a : defaultApplyPatch;
    return async function* applyLiveQueryPatch(asyncIterator) {
        let mutableData = null;
        let lastRevision = 0;
        for await (const result of asyncIterator) {
            // no revision means this is no live query patch.
            if ("revision" in result && result.revision) {
                const valueToPublish = {};
                if (result.revision === 1) {
                    if (!result.data) {
                        throw new Error("Missing data.");
                    }
                    valueToPublish.data = result.data;
                    mutableData = result.data;
                    lastRevision = 1;
                }
                else {
                    if (!mutableData) {
                        throw new Error("No previousData available.");
                    }
                    if (!result.patch) {
                        throw new Error("Missing patch.");
                    }
                    if (lastRevision + 1 !== result.revision) {
                        throw new Error("Wrong revision received.");
                    }
                    mutableData = applyPatch(mutableData, result.patch);
                    valueToPublish.data = mutableData;
                    lastRevision++;
                }
                if (result.extensions) {
                    valueToPublish.extensions = result.extensions;
                }
                if (result.errors) {
                    valueToPublish.errors = result.errors;
                }
                yield valueToPublish;
                continue;
            }
            yield result;
            yield* asyncIterator;
        }
    };
};
//# sourceMappingURL=createApplyLiveQueryPatch.js.map